exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/features/components/landing-pages/feature-option-tokens-welcome/feature-option-tokens-welcome.component.scss
// module id = ../../../../../src/app/modules/features/components/landing-pages/feature-option-tokens-welcome/feature-option-tokens-welcome.component.scss
// module chunks = main